import axios from '../api/axios';

export async function getLogos() {
  const res = await axios.get(`/logos`);

  return res.data;
}

export async function createLogo(body) {
  const response = await axios.post('/logos', body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export async function deleteLogo(logoId) {
  const response = await axios.delete(`/logos/${logoId}`);
  return response;
}
